/**
 * account-owners
 * Created by john
 * Date: 2019-07-13
 * Email: maiqingqiang@gmail.com
 * Time: 21:43
 */
import entityFactory from './entityFactory';
import {bindActionCreators} from "redux";

const namespace = 'wechat-group';

export const {types, actions, reducer} = entityFactory(namespace);

export default reducer;

export const getAccountOwners = state => state.entities.accountOwners;

export const getAccountOwnersActions = dispatch => bindActionCreators(actions, dispatch);